import { render, staticRenderFns } from "./medicalInsuranceDivision.vue?vue&type=template&id=64070f12&scoped=true&"
import script from "./medicalInsuranceDivision.vue?vue&type=script&lang=js&"
export * from "./medicalInsuranceDivision.vue?vue&type=script&lang=js&"
import style0 from "./medicalInsuranceDivision.vue?vue&type=style&index=0&id=64070f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64070f12",
  null
  
)

export default component.exports